
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 30"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"48","height":"30","fill":"#008CFF","rx":"2"}}),_c('path',{attrs:{"fill":"#fff","d":"M25.957 7.146c.35.754.572 1.669.572 3.012 0 2.454-1.682 6.054-3.046 8.344l-1.459-12.11-6.024.59L18.76 24h6.88c3.012-4.09 6.724-9.916 6.724-14.4 0-1.406-.286-2.52-.92-3.6z"}})])
          )
        }
      }
    